import { constructAsync } from '../../../webmodule-common/other/async-constructor';
import { customElement, state } from 'lit/decorators.js';
import { disposeOf } from '../../../webmodule-common/other/dispose';
import { html } from 'lit';
import { refreshAllUserCache } from '../../dealer/data/all-user-cache';
import { SupportInboxView } from '../../dealer/view/supportinbox-view';
import { TabbedPageBase } from './helpers/page-base';
import { tlang } from '../../../webmodule-common/other/language/lang';

@customElement('app-support-inbox')
export class AppSupportInbox extends TabbedPageBase {
  @state()
  view: SupportInboxView | null = null;

  constructor() {
    super();
  }

  async dispose() {
    await super.dispose();
    await disposeOf(this.view);
    this.view = null;
  }

  render() {
    if (!this.loggedIn) return html``;
    return html` <div class="page-content support-inbox-content">
      <div class="page-container">${this.view?.ui}</div>
    </div>`;
  }

  meta() {
    return {
      title: tlang`Support Tickets`,
      description: tlang`Support Tickets`
    };
  }

  protected async canLeavePage(): Promise<boolean> {
    if (this.view) return await this.view.canClose();
    else return true;
  }

  protected createRenderRoot(): HTMLElement | DocumentFragment {
    return this;
  }

  protected async viewFactory(): Promise<SupportInboxView> {
    return await constructAsync(new SupportInboxView());
  }

  protected async afterUserConnected() {
    await refreshAllUserCache();
    this.view = await this.viewFactory();
    await super.afterUserConnected();
  }

  protected async setActiveTabByHash() {
    await this.view?.setActiveTabByHash();
  }
}
